module.exports = __webpack_public_path__ + "media/images/navPanel-6d18420ee3fa6d393dab5c394d10765b.svg";